var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalLogoWithTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 334.624,
    height: 106.594,
    viewBox: "0 0 334.624 106.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "horizontal-logo-withTitle",
    transform: "translate(-522.376 -358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(505 358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30480",
    "data-name": "Group 30480",
    transform: "translate(-304.128 -291.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30478",
    "data-name": "Group 30478",
    transform: "translate(321.503 291.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30476",
    "data-name": "Group 30476",
    transform: "translate(0 0.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31223",
    "data-name": "Path 31223",
    d: "M417.579,384.473c-8.919,0-13.908-1.443-15.642-4.5-2.642-4.664,3.281-10.119,7.967-13.816l2.3,2.915c-6.2,4.9-7.7,7.9-7.036,9.07.377.666,2.5,2.823,14.037,2.6,7.886-.149,18.663-1.4,31.165-3.628,24.237-4.313,51.932-11.67,70.556-18.744,17.4-6.61,20.653-10.684,20.436-11.7-.021-.1-.656-2.421-13.038-3.541-10.157-.92-25.617-.788-45.949.391-21.576,1.251-33.371-1.844-36.056-9.462-2.256-6.4,2.439-15.32,13.953-26.515a167.336,167.336,0,0,1,17.317-14.519l2.158,3.023a166.769,166.769,0,0,0-16.914,14.186c-10.072,9.8-14.693,17.822-13.011,22.591,1.4,3.962,8.141,8.391,32.338,6.989,20.515-1.19,36.159-1.318,46.5-.382,10.546.954,15.584,2.948,16.335,6.464.62,2.9-1.065,7.707-22.749,15.944-18.821,7.149-46.779,14.579-71.224,18.929-12.691,2.258-23.668,3.532-31.746,3.685Q418.4,384.473,417.579,384.473Z",
    transform: "translate(-401.283 -293.029)",
    fill: "#7684af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30477",
    "data-name": "Group 30477",
    transform: "translate(19.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31224",
    "data-name": "Path 31224",
    d: "M508.443,397.946a53.062,53.062,0,0,1-19.285-3.6l1.344-3.462a49.629,49.629,0,1,0-17.99-12.071l-2.691,2.559a53.293,53.293,0,1,1,38.622,16.571Z",
    transform: "translate(-455.15 -291.361)",
    fill: "#7684af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(8 -10.852)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "YOUR_GROUND",
    "data-name": "YOUR GROUND",
    transform: "translate(464.128 386.635)",
    fill: "#97a2d9",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300,
    letterSpacing: "0.6em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "YOUR GROUND")), /*#__PURE__*/React.createElement("g", {
    id: "Group_30479",
    "data-name": "Group 30479",
    transform: "translate(478.122 320.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31225",
    "data-name": "Path 31225",
    d: "M519.751,695.681c-2.355,8.016-4.676,15.913-6.994,23.81-.832,2.836-1.65,5.675-2.486,8.509a5.077,5.077,0,0,1-.575,1.535,1.954,1.954,0,0,1-1.232.873,1.853,1.853,0,0,1-1.211-.883,7.019,7.019,0,0,1-.6-1.744q-5.339-17.636-10.671-35.273c-.494-1.635-.346-2.351.519-2.677.908-.342,1.747.319,2.214,1.878q4.317,14.413,8.6,28.836c.333,1.115.685,2.224,1.166,3.782.438-1.329.765-2.24,1.039-3.167q4.136-14.01,8.261-28.023a14.775,14.775,0,0,1,.873-2.521c.618-1.218,1.659-1.192,2.3.024a9.34,9.34,0,0,1,.614,1.743l9,30.6c.1.326.246.635.509,1.3,1.023-3.373,1.959-6.431,2.877-9.495q3.4-11.352,6.794-22.706a3.674,3.674,0,0,1,.631-1.5,2.174,2.174,0,0,1,1.519-.713,1.16,1.16,0,0,1,.922,1.563c-.121.535-.248,1.07-.407,1.6q-5.354,17.739-10.72,35.475a5.787,5.787,0,0,1-.411,1.16,1.289,1.289,0,0,1-2.413,0,11.879,11.879,0,0,1-.8-2.331q-4.485-15.427-8.958-30.857a7.309,7.309,0,0,0-.36-.8Z",
    transform: "translate(-456.687 -689.622)",
    fill: "#97a2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31226",
    "data-name": "Path 31226",
    d: "M720.947,724.251V693.165a5.806,5.806,0,0,1,.118-2.041,2.4,2.4,0,0,1,1.306-1.351c.768-.208,1.211.5,1.347,1.234a10.166,10.166,0,0,1,.166,1.841q.014,17.229,0,34.457c0,1.142.255,2.6-1.091,3.063-1.457.506-1.919-1.012-2.576-1.892-8.1-10.857-16.214-21.7-24.231-32.621a8.037,8.037,0,0,0-7.008-3.558c-4.884.035-9.768.006-14.652.014-.54,0-1.081.065-1.848.114-.046.85-.125,1.645-.126,2.44q-.012,16.2-.01,32.394a5.544,5.544,0,0,1-.158,2.033,1.834,1.834,0,0,1-1.29,1.029,2.019,2.019,0,0,1-1.365-.975,3.286,3.286,0,0,1-.2-1.606q-.013-17.641,0-35.283c0-2.413.48-2.874,2.925-2.88q8.564-.022,17.128,0a10.32,10.32,0,0,1,8.741,4.593c7.4,10.086,14.871,20.121,22.315,30.175Z",
    transform: "translate(-568.881 -689.524)",
    fill: "#97a2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31227",
    "data-name": "Path 31227",
    d: "M398.2,689.45c5.427.212,9.383,1.356,12.8,4.074.161.128.336.242.488.38.618.564,1.322,1.117.644,2.073-.555.782-1.32.856-2.309.047a16.143,16.143,0,0,0-9.021-3.678,16.59,16.59,0,0,0-8.406,1.5c-3.478,1.573-4.2,7.644-1.108,9.784a30.336,30.336,0,0,0,5.2,2.868c2.453,1.06,5.043,1.8,7.513,2.823a33.576,33.576,0,0,1,4.938,2.522c5.6,3.5,7.049,12.179-.311,16.435a16.878,16.878,0,0,1-10.1,2.06,21.361,21.361,0,0,1-10.715-3.832,9.3,9.3,0,0,1-2.017-1.741c-.307-.386-.473-1.405-.258-1.576a3.249,3.249,0,0,1,1.815-.428c.27-.009.565.351.827.57a18.068,18.068,0,0,0,14.22,4.133,11.575,11.575,0,0,0,6.34-2.756c2.774-2.4,2.7-7.277-.4-9.838a24.135,24.135,0,0,0-5.68-3.244c-2.571-1.134-5.293-1.919-7.9-2.978a28.847,28.847,0,0,1-4.2-2.177,7.915,7.915,0,0,1-4.075-7.787,8.584,8.584,0,0,1,5.819-7.818,44.859,44.859,0,0,1,5.891-1.421Z",
    transform: "translate(-385.435 -689.45)",
    fill: "#97a2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31228",
    "data-name": "Path 31228",
    d: "M738.073,727.567V741.15a10.964,10.964,0,0,1-.094,1.844c-.133.774-.7,1.311-1.446,1.108-.45-.123-.841-.738-1.089-1.22a2.9,2.9,0,0,1-.053-1.219q0-14.1,0-28.195a3.311,3.311,0,0,1,.077-1.419c.25-.475.77-1.1,1.187-1.113a1.845,1.845,0,0,1,1.278,1.019,4.565,4.565,0,0,1,.14,1.823Q738.08,720.672,738.073,727.567Z",
    transform: "translate(-611.541 -703.334)",
    fill: "#97a2d9"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLogoWithTitle);
export default __webpack_public_path__ + "static/media/horizontal-logo-withTitle.4711c026371fc72926a83d0dd1834e2c.svg";
export { ForwardRef as ReactComponent };